import axios from 'axios'

export default {
  namespaced: true,
  state: {
    exerciseId: null,
    owner: null,
    shortId: null,
    exerciseTitle: '',
    bots: [],
    currentBotId: null,
    backgroundStore: [],
    activePlayModes: {},
    type: null
  },
  mutations: {
    CLEAR_STATE: (state) => {
      state.exerciseId = null;
      state.owner = null;
      state.exerciseTitle = '';
      state.bots = [];
      state.answers = [];
      state.history = [];
      state.path = [];
      state.currentBotId = null;
      state.saving = false;
      state.saved = false;
      state.dataLoaded = false;
      state.backgroundStore = [];
      state.activePlayModes = {};
      state.personStore = [];
      state.type = null;
    },
    LOAD_DATA: (state, data) => {
      state.exerciseId = data._id;
      state.owner = data.owner;
      state.shortId = data.shortId;
      state.exerciseTitle = data.title;
      state.bots = data.bots;
      state.currentBotId = data.bots[0].id;
      state.backgroundStore = data.backgroundStore;
      state.activePlayModes = data.activePlayModes || {play: true, learn: true, record: true};
      state.type = data.type;
    }
  },
  actions: {
    loadData: ({commit}, exerciseId) => {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}hubLoadExercise`,
          data: {
            exerciseId
          }
        }).then(result => {
          commit('LOAD_DATA', result.data.exercise);
          resolve();
        }).catch(err => {
          reject(err.response.data.error);
        })
      })
    },
    clear: ({commit}) => {
      commit('CLEAR_STATE');
    }
  },
  getters: {
    currentBotData: (state) => {
      return state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
    },
    getTitle: (state) => {
      return state.exerciseTitle;
    },
    getExerciseId: (state) => {
      return state.exerciseId;
    },
    getCurrentBotBg: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      return currentBot[0].background;
    },
    getBackgroundStore: (state) => {
      return state.backgroundStore;
    },
    getOwner: (state) => {
      return state.owner;
    },
    getShortId: (state) => {
      return state.shortId;
    },
    getType: (state) => {
      return state.type;
    },
    getActivePlayModes: (state) => {
      return state.activePlayModes;
    }
  }
}